import {LoadingOutlined, QuestionCircleTwoTone} from "@ant-design/icons";
import {Breadcrumb, Card, Descriptions, Popover, Spin} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {AppContextContext, SoftwareLicenseServiceContext} from "../../Contexts";
import {DocumentTitle} from "../DocumentTitle";
import "./SoftwareLicenseDetail.module.css";
import * as globalStyles from "../App.module.css";
import SoftwareLicense from "../../domain/SoftwareLicense";
import {ResourceOwnerType} from "../../domain/ResourceOwnerType";
import {formatSoftwareLicenseOrigin} from "../../domain/SoftwareLicenseOrigin";
import * as styles from "./SoftwareLicenseDetail.module.css";
import {formatSoftwareLicenseCategory} from "./functions";

function SoftwareLicenseDetail() {
    const appContext = useContext(AppContextContext);
    const softwareLicenseService = useContext(SoftwareLicenseServiceContext);
    const {licenseId}: any = useParams();
    const [license, setLicense] = useState<SoftwareLicense>();

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        reload();
    }, [licenseId])

    return (
        <DocumentTitle title={license?.name}>
            <>
                <Breadcrumb className={globalStyles["common__breadcrumb"]}>
                    <Breadcrumb.Item>{appContext.config?.appName}</Breadcrumb.Item>
                    <Breadcrumb.Item><Link to={"/software-licenses"}>Software licenses</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>{license?.name}</Breadcrumb.Item>
                </Breadcrumb>

                <Spin spinning={!license} indicator={<LoadingOutlined style={{fontSize: 24}} spin={true}/>}>
                    <h1>{license?.name}</h1>

                    <Descriptions column={1} bordered={true} size="small" className={globalStyles.details}>
                        {license?.owner === ResourceOwnerType.ORGANIZATION && <Descriptions.Item label={"Owner"}>{license?.organization?.name}</Descriptions.Item>}
                        {license?.owner === ResourceOwnerType.SYSTEM && <Descriptions.Item label={"Owner"}><i>System license</i></Descriptions.Item>}
                        <Descriptions.Item label={"Origin"}>{formatSoftwareLicenseOrigin(license)}</Descriptions.Item>
                        {appContext.user.isSystemAdmin() && <Descriptions.Item label={"License key"}>{license?.licenseKey}</Descriptions.Item>}
                        <Descriptions.Item label={"Short name"}>{license?.shortName}</Descriptions.Item>
                        <Descriptions.Item label={"Name"}>{license?.name}</Descriptions.Item>
                        <Descriptions.Item label={"SPDX identifiers"}>{license?.allSpdxLicenseKeys?.map(license => <div>{license}</div>)}</Descriptions.Item>
                        {license?.aliases?.length > 0 && <Descriptions.Item label={"Aliases"}>{license?.aliases.map(alias => <div>{alias}</div>)}</Descriptions.Item>}
                        <Descriptions.Item label={"License owner"}>{license?.licenseOwner}</Descriptions.Item>
                        <Descriptions.Item label={"Category"}>
                            {license?.category} <Popover title={license?.category} content={formatSoftwareLicenseCategory(license?.category)} overlayStyle={{maxWidth: 400}}><QuestionCircleTwoTone/></Popover>
                        </Descriptions.Item>
                        {license?.homepageUrl && <Descriptions.Item label={"Homepage"}><Link to={license?.homepageUrl}>{license?.homepageUrl}</Link></Descriptions.Item>}
                        {appContext.user.isSystemAdmin() && <Descriptions.Item label={"Last modified"}>{license?.lastModified}</Descriptions.Item>}
                    </Descriptions>

                    <Card title="License text" className={styles.card}>
                        {license?.text && <code className={styles.text}>{license?.text}</code>}
                    </Card>
                </Spin>
            </>
        </DocumentTitle>
    )

    function reload() {
        softwareLicenseService.get(licenseId!).then(setLicense);
    }

}

export default SoftwareLicenseDetail;
